import React from 'react'
import EveryOne from '../../2x2/everyoneorder/EveryOne'

const EveryoneSecond = () => {
  return (
    <>
   <table className='table-one-game'>
        <tr className='table-hd'>
          <td>Period</td>
          <td>User</td>
          <td>Select</td>
          <td>Point</td>
        </tr>
        <EveryOne/>
      </table>
    </>
  )
}

export default EveryoneSecond